import type { FaireProductEntity } from "../../entity_types/product";

export const p_2ae32gy76n: FaireProductEntity = {
  token: "p_2ae32gy76n",
  type: "product",
  name: "Mini Unicorn Head",
  brandToken: "b_8vajze9chy",
  brandName: "The Bomb Bar",
  imageUrl:
    "https://cdn.faire.com/fastly/e2b245b88f5b6df4f29cdb745c105680dc3a4da542eb1628c053c2b8ff3b5150.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5221f01677f8b2ee55676ddf185ce26d14859e3cc7d451f2f1994e987220d835.jpeg",
    "https://cdn.faire.com/fastly/4abcb5a5063f89f54089217371c60a9de9d5c44cd929e9f4934fced588785ac7.jpeg",
  ],
  priceDollars: 1.95,
  description:
    "Delight in the myth and majesty of the mystical mini-purple unicorn head! Enjoy the vibrant grape scent it will bring you, and feel the magic of the unicorn world. Transform ordinary baths into purple unicorn adventures with this fun and fizzy bath bomb!\n\nGrape & Unicorns World\n\n𝐈𝐧𝐠𝐫𝐞𝐝𝐢𝐞𝐧𝐭𝐬\n\nSodium Bicarbonate, Citric Acid, Zea Mays, Milk Powder, Canola Oil, Aqua, Parfum, FD&C Colour",
  tags: [],
  msrpDollars: 3.9,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:49:04.427Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
